import { Box, Typography } from "@mui/material";
import Header from "../../components/Header";
import { useTranslation } from "react-i18next";

const Deposit = () => {
  const { t } = useTranslation();
  return (
    <Box m="20px">
      <Header
        title={t("DEPOSIT")}
        subtitle={t("List of Deposit")}
      />
      
      <Typography variant="h3">
        {t("A section of the site is under development...")}
      </Typography>
    </Box>
  )
}

export default Deposit
